import { ComboboxMulti } from "@/components/ui/combobox_mutli";
import type { CrmRules } from "@/lib/api/crm/rules";
import { tagOptions, type CrmTagTarget } from "../tagOptions";

/**
 * Multi-select of the tags GET /crm/rules allows on the target. Tags already chosen stay listed
 * (by name) even when no longer allowed, so the server can name them instead of the picker hiding them.
 */
export function TagPicker({
  id,
  rules,
  target,
  value,
  onChange,
  disabled,
  placeholder = "Choose tags",
}: {
  id?: string;
  rules: CrmRules;
  target: CrmTagTarget;
  value: string[];
  onChange: (tagIds: string[]) => void;
  disabled?: boolean;
  placeholder?: string;
}) {
  const allowed = tagOptions(rules, target);
  const chosenElsewhere = value
    .filter((tagId) => !allowed.some((option) => option.value === tagId))
    .map((tagId) => ({ value: tagId, label: rules.tags[tagId]?.name ?? "Unknown tag" }));

  return (
    <ComboboxMulti
      id={id}
      isModal
      dwimOnChange
      showSelectAll={false}
      className="w-full"
      virtualizeList
      popoverClassName='md:min-w-[300px] lg:min-w-[400px] xl:min-w-[500px]'
      placeholder={placeholder}
      options={[...allowed, ...chosenElsewhere]}
      value={value}
      onValueChange={onChange}
      disabled={disabled}
    />
  );
}
